export default function isOkResponse(response: unknown) {
    return typeof response === 'object' && response !== null && 'result' in response && response['result'] === 'OK';
}
